export const IMPORTANT_INFO_MESSAGE =
    'You are chatting with ChatBLK™, an AI-powered service that aims to answer your investment questions with a knowledge ' +
    "base built on BlackRock's insights. It is not moderated or checked by human reviewers, and its output may contain " +
    'errors, inaccuracies, or biases, so please verify all relevant information with other sources before using it or ' +
    'relying upon it. ChatBLK™ does not and is not intended to provide professional or investment advice and should not ' +
    'be relied upon for investment decisions or for any other similar purpose. Please do not enter any proprietary, ' +
    'confidential, or personal information when asking ChatBLK™ questions. ChatBLK™ collects login IDs solely for ' +
    'telemetry purposes. No personal information is gathered for product improvement purposes, all user metrics ' +
    'reporting is done on an aggregate level. For further information on Privacy and Data Protection, please find our ' +
    'Client and Vendor Privacy Notice.';

export const WELCOME_PAGE_HEADER_TEXT = 'AI-powered assistance';

export const WELCOME_MESSAGE_BOLD = 'Welcome!';

export const WELCOME_MESSAGE_BODY =
    'Ask a question and get instant answers about our products, strategies, and market insights';

export const DISCLAIMER_MESSAGE =
    'ChatBLK uses AI. Do not enter any proprietary, confidential or personal info. AI may produce incorrect answers and does not provide investment advice. BlackRock collects login IDs and retains conversations. Queries are used for quality assurance and user metrics.';

export const SERVER_IS_RESPONDING_MESSAGE = 'Responding...';

export const RESET_WARNING_MESSAGE =
    'Are you sure you want to reset your conversation? This cannot be undone.';

export const SUMMARIZE_PROMPT = 'Summarize this page';

export const DEFAULT_INVALID_SUMMARY_RESPONSE =
    "I'm sorry, but I'm not currently trained to answer questions of this type.";

export const ERROR_MESSAGE_SPACER = ' | ';

export const CONTACT_RM__HEADER = 'Your contacts at BlackRock';

export const CONTACT_RM_DEFAULT_HEADER = 'Ways to contact BlackRock';

// The header for the contact RM page after the response is received from the API and relationship managers have been identified.
export const CONTACT_RM_DEFAULT_SUBHEADER =
    'Contact the BlackRock team to learn more about our investment solutions, portfolio tools, and advisor resources.';

export const DEFAULT_EMAIL_CONTACT = 'Askblackrock@blackrock.com';

export const DEFAULT_PHONE_CONTACT = '877-275-1255 (1-877-ASK-1BLK)';

export const DEFAULT_SCHEDULE_URI =
    'https://www.timetrade.com/app/blackrock/workflows/LPA/schedule?locationId=uswablackrock&appointmentTypeGroupId=driftwebex&appointmentTypeId=ac_cu&ch=chatblk';

export const DEFAULT_BUSINESS_HOURS = '8:30 a.m. - 6 p.m. ET';

export const COPY_TOOLTIP_LABEL = 'Copy';

export const COPY_TOOLTIP_SUCCESS_LABEL = 'Copied!';

export const SCHEDULE_MEETING_LABEL = 'Schedule a meeting';

export const CHAT_PROMPT_CAROUSEL_DATA_LINK_EVENT =
    'chatblk | featured | prompt';

export const MENU_ACTION_BUTTONS_DATA_LINK_EVENTS = {
    'bxf-contact': 'chatblk | menu | contact rm | open',
    'bxf-new-chat': 'chatblk | menu | reset',
    'bxf-history': 'chatblk | menu | recent prompts | open',
    'bxf-full-screen': 'chatblk | menu | maximize',
    'bxf-exit-full-screen': 'chatblk | menu | minimize',
    'bxf-dismiss': 'chatblk | menu | dismiss',
};

export const CHAT_BUBBLE_DATA_LINK_EVENTS = {
    /** data-link-event for similar questions button */
    similarQuestionsButton: 'chatblk | similar question | prompt',

    /** data-link-event for follow up questions button */
    followUpQuestionsButton: 'chatblk | follow up | prompt',

    /** data-link-event for submit feedback button */
    submitFeedbackButton: 'chatblk | result | feedback | submit',

    /** data-link-event for copy button */
    copyButton: 'chatblk | result | copy',

    /** data-link-event for sources accordion expansion panel */
    accordionExpansionPanelButton: 'chatblk | result | sources',

    /** data-link-event for feedback thumbs up radio button */
    feedbackThumbsUpRadioButton: 'chatblk | result | like',

    /** data-link-event for feedback thumbs down radio button */
    feedbackThumbsDownRadioButton: 'chatblk | result | dislike',
};

export const CHAT_CANVAS_DATA_LINK_EVENTS = {
    /** data-link-event for login button */
    loginButton: 'chatblk | button | link click | get started',

    /** data-link-event for close button */
    closeButton: 'chatblk | menu | contact rm | close',

    /** data-link-event for dismiss button */
    dismissButton: 'chatblk | dismiss',

    /** data-link-event for recent prompt button */
    recentPromptsButton: 'chatblk | prompt | recent',

    /** data-link-event for menu action buttons */
    menuActionButtons: {
        ...MENU_ACTION_BUTTONS_DATA_LINK_EVENTS,
    },
};
export const CHAT_BLK_PANEL_TAGLINE = 'Your AI-powered assistant';
export const FALLBACK_STARTER_PROMPTS = [
    'New to AC, what are some resources to explore?',
    'BlackRock’s latest market insights?',
    'Does BlackRock offer bitcoin investing?',
    'What is Aperio?',
    'Does BlackRock offer 529 plans?',
    'What models does BlackRock offer?',
    'What SMA solutions does BlackRock offer?',
    'How does BlackRock support retirement?',
    'How to access private market opportunities?',
    'What are option overlay strategies?',
    'What is Aladdin for investors?',
    'BlackRock solutions for high-net-worth?',
    'Benefits of BlackRock portfolio consulting?',
    'BlackRock’s approach to alternatives?',
    'How to access BlackRock model portfolios?',
    'BlackRock’s investor/advisor resources?',
    'Tax / Other Campaign',
    'Where to find capital gains estimates?',
    'What tax solutions does BlackRock offer?',
    'General strategies to find tax-efficient ETFs',
    'Learn about tax-efficient portfolio strategies',
];
